import { TextFieldComponent } from "@/components/add-v2/textFieldComponent";
import { TextAreaComponent } from "@/components/add-v2/textAreaComponent";
import { RadioComponent } from "@/components/add-v2/radioComponent";
import { CheckboxComponent } from "@/components/add-v2/checkboxComponent";
import { PhotoPickerComponent } from "@/components/add-v2/photoPickerComponent";
import { LocationPickerComponent } from "@/components/add-v2/locationPickerComponent";
import { PremiumsFieldComponent } from "@/components/add-v2/premiumsFieldComponent";
import { VideoUploadComponent } from "@/components/add-v2/videoUploadComponent";
import { SliderFieldComponent } from "@/components/add-v2/sliderFieldComponent";

export function dispatchCtxChange(target, data) {
  target.dispatchEvent(
    new CustomEvent("ctxchange", {
      detail: data,
      bubbles: true,
    }),
  );
}

export function dispatchCtxUiEvent(target, data) {
  target.dispatchEvent(
    new CustomEvent("ctxuievent", {
      detail: data,
      bubbles: true,
    }),
  );
}

export function onChange(data) {
  dispatchCtxChange(document.body, data);
}

export default {
  text: TextFieldComponent,
  string: TextFieldComponent,
  float: TextFieldComponent,
  int: TextFieldComponent,

  premiums: PremiumsFieldComponent,

  textArea: TextAreaComponent,
  slider: SliderFieldComponent,
  radio: RadioComponent,

  mediaPicker: PhotoPickerComponent,
  videoUpload: VideoUploadComponent,
  locationPicker: LocationPickerComponent,

  checkbox: CheckboxComponent,
  boolean: CheckboxComponent,
};
